import api from './api';

/*
 * Operational Issues (ТЗ №2, OPS-ISSUES03). Всё через общий axios instance /api;
 * lifecycle/severity/trend/criteria/explanation — только из backend.
 */

/** ТЗ №2 §4: status/factory_id/camera_id/limit/offset. */
export const listOperationalIssues = (params = {}, { signal } = {}) =>
  api.get('/operational-issues', { params, signal }).then((r) => r.data);

/** ТЗ №2 §8: detail + supporting_events. Недоступный → 404. */
export const getOperationalIssue = (issueId, { signal } = {}) =>
  api.get(`/operational-issues/${encodeURIComponent(issueId)}`, { signal }).then((r) => r.data);

/** ТЗ №2 §3: admin-only singleton настройка периода анализа. */
export const getOperationalIssueSettings = () =>
  api.get('/admin/operational-issues/settings').then((r) => r.data);

/** Body ровно {window_days}; success ≠ applied — вызывающий читает response.pending. */
export const updateOperationalIssueSettings = ({ window_days }) =>
  api.put('/admin/operational-issues/settings', { window_days }).then((r) => r.data);

/*
 * OPS-ISSUES04 (ТЗ v4 §30): archive / restore / delete одним запросом.
 * all-or-nothing и идемпотентно: «уже в этом состоянии» — не ошибка, счётчики
 * приходят из ответа. Delete остаётся soft/tombstone и не трогает связанные
 * события и доказательства.
 */
export const bulkOperationalIssueAction = ({ issue_ids, action, confirm = true }) =>
  api.post('/operational-issues/bulk', { issue_ids, action, confirm }).then((r) => r.data);
